import React, { useMemo } from 'react';
import { useMMDataContext } from '../../../contexts/MMDataContext';

import { KeyMetricChartData } from 'src/components/organisms/KeyMetricChart';
import { useCPULabel } from 'src/features/MM/hooks/useCPULabel';
import { getAggregateLevelData } from 'src/features/MM/utils/getAggregateLevelData';
import { AggregateLevel } from 'src/types';
import { KeyMetricItem } from 'src/features/MM/components/molecules/KeyMetricItem';
import { Icon } from 'src/components/atoms/Icon';
import { calculateTrendFromTimeSeries } from 'src/features/MM/utils/calculateTrendFromTimeSeries';

type CostPerUnitProps = {
  aggregateLevel: AggregateLevel;
};

export const CostPerUnit: React.FC<CostPerUnitProps> = ({ aggregateLevel }) => {
  const { cpu } = useMMDataContext();

  const label = useCPULabel();

  const keyMetricData: KeyMetricChartData = useMemo(() => {
    return {
      isLoading: cpu.isLoading,
      isError: cpu.isError,
      name: label,
      isEuro: true,
      summaryValue: cpu.total,
      data: getAggregateLevelData(cpu, aggregateLevel),
    };
  }, [cpu, label, aggregateLevel]);

  const { upOrDown, upOrDownValue } = useMemo(() => {
    return calculateTrendFromTimeSeries(keyMetricData?.data ?? []);
  }, [keyMetricData]);

  return (
    <KeyMetricItem
      title="Cost per unit"
      upOrDown={upOrDown}
      upOrDownValue={upOrDownValue}
      value={keyMetricData.summaryValue}
      icon={<Icon iconName="tag" />}
    />
  );
};
